import ViewportUtil from './viewportUtil';
import ViewportEvents from './viewportEvents';
import EventDispatcher from '@/core/event/eventDispatcher';


let singleton = Symbol();
let singletonEnforcer = Symbol();

let breakpoint,
    viewport_resizeHandler,
    viewport_orientationChangeHandler;

const RESIZE_DELAY = 300;

class ViewportController {

    private updateTimer?:number

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error('Cannot construct ViewportController singleton');
        }

        breakpoint = ViewportUtil.breakpoint;

        viewport_resizeHandler = () => this.viewport_resizeHandler();
        viewport_orientationChangeHandler = event => this.viewport_orientationChangeHandler(event);

        window.addEventListener('resize', viewport_resizeHandler, false);
        window.addEventListener('orientationchange', viewport_orientationChangeHandler, false);
    }

    viewport_resizeHandler() {
        if (breakpoint !== ViewportUtil.breakpoint) {
            breakpoint = ViewportUtil.breakpoint;

            EventDispatcher.dispatchEvent(new ViewportEvents(ViewportEvents.BREAKPOINT_CHANGE, breakpoint));
        }

        EventDispatcher.dispatchEvent(new ViewportEvents(ViewportEvents.RESIZE, 'resize'));

        // DELAYED_RESIZE
        if(this.updateTimer){
            window.clearTimeout(this.updateTimer);
        }
        this.updateTimer = window.setTimeout(() => this.viewport_delayedResizeHandler(), RESIZE_DELAY);
    }

    viewport_delayedResizeHandler() {
        EventDispatcher.dispatchEvent(new ViewportEvents(ViewportEvents.DELAYED_RESIZE, 'resize'));
    }

    viewport_orientationChangeHandler(event: { orientation: string }) {
        let orientation:string

        if (event.orientation !== undefined) {
            orientation = event.orientation;
        } else if (ViewportUtil.isPortait()) {
            orientation = 'portrait';
        } else {
            orientation = 'landscape';
        }

        EventDispatcher.dispatchEvent(new ViewportEvents(ViewportEvents.ORIENTATION_CHANGE, orientation));
    }

    static get instance():ViewportController {
        if (!this[singleton]) {
            this[singleton] = new ViewportController(singletonEnforcer);
        }
        return this[singleton];
    }

    public init() {
        // pass
    }
}

export default ViewportController;
